/**
 * 標準フォーマット利用項目管理からセグメントの利用項目を重複なしで取得する関数
 *
 * @param {Object[]} standardFormatUsageItems - 標準フォーマット利用項目管理の配列
 * @returns {Object[]} 重複なしのUsedItems配列
 */
export function getUniqueSegmentItems(standardFormatUsageItems) {
  const seenCodeNamePairs = new Set()
  const uniqueUsedItems = []

  for (const item of standardFormatUsageItems) {
    if (!item.UsedItems || !Array.isArray(item.UsedItems)) continue

    for (const usedItem of item.UsedItems) {
      const key = `${usedItem['事業セグメントコード']}:${usedItem['事業セグメント名称']}`
      if (!seenCodeNamePairs.has(key)) {
        seenCodeNamePairs.add(key)
        uniqueUsedItems.push(usedItem)
      }
    }
  }
  return uniqueUsedItems
}

/**
 * 変更されたセグメント名が標準フォーマット利用項目管理で使用されているかチェックし、 エラー対象となるセグメントのID配列を返す関数
 *
 * @param {Object[]} standardFormatUsageItems - 標準フォーマット利用項目管理の配列
 * @param {Object[]} segmentState - 現在のセグメント状態の配列
 * @param {function(string): Object|null} getInitialDataBySegment - セグメントIDを受け取り、初期データオブジェクトを返す関数
 * @returns {string[]} エラー対象となるセグメントのID配列（重複なし）
 */
export function getConflictEditedSegmentIds(standardFormatUsageItems, segmentState, getInitialDataBySegment) {
  const usedItems = getUniqueSegmentItems(standardFormatUsageItems)
  const usedSegmentNames = new Set(usedItems.map((item) => item['事業セグメント名称']))

  const editedSegments = {}
  for (const seg of segmentState) {
    if (seg.uiState && seg.uiState.hasChanges === true) {
      const initialItem = getInitialDataBySegment(seg.searchKey)
      const initialSegmentName = initialItem?.segmentName || seg.segmentName || ''
      editedSegments[initialSegmentName] = seg.searchKey
    }
  }

  const errorIds = new Set()
  for (const name of usedSegmentNames) {
    if (editedSegments[name]) {
      errorIds.add(editedSegments[name])
    }
  }
  return Array.from(errorIds)
}
